/** Handles mobile-specific drag-and-drop interactions and task reordering. */
import { useDndMonitor } from '@dnd-kit/core';
import {
  handleDailyTaskReorder,
  handleNextActionReorder,
  handleOverdueToTodayDrop,
  handleNextActionToTodayDrop,
} from '@/features/tasks/utils/interactions/mobileDndUtils';

const reorderDailyTasks = (active, over, context) => {
  handleDailyTaskReorder(
    active,
    over,
    context.todayTasks,
    context.user,
    context.updateTask,
  );
};

const reorderOverdueToToday = (active, over, context) => {
  handleOverdueToTodayDrop(
    active,
    over,
    context.todayTasks,
    context.allTasks,
    context.user,
    context.updateTask,
  );
};

const reorderNextActions = (active, over, context) => {
  handleNextActionReorder(
    active,
    over,
    context.nextActions,
    context.allTasks,
    context.user,
    context.moveTask,
  );
};

const reorderNextActionToToday = (active, over, context) => {
  handleNextActionToTodayDrop(
    active,
    over,
    context.todayTasks,
    context.allTasks,
    context.user,
    context.updateTask,
  );
};

const DISPATCHERS = {
  'daily-task:daily-task': reorderDailyTasks,
  'overdue-task:daily-task': reorderOverdueToToday,
  'next-action:next-action': reorderNextActions,
  'next-action:daily-task': reorderNextActionToToday,
};

const dispatchReorder = (active, over, context) => {
  const activeType = active.data.current?.type;
  const overType = over.data.current?.type;
  const key = `${activeType}:${overType}`;
  const handler = DISPATCHERS[key];
  if (handler) handler(active, over, context);
};

const processDragEnd = (event, context) => {
  const { active, over } = event;
  if (over && active.id !== over.id) {
    dispatchReorder(active, over, context);
  }
};

/**
 * Encapsulates dnd-kit drag-end logic for TodayView.
 * @param {Object} context
 */
const useMobileDndReorder = (context) => {
  useDndMonitor({
    onDragEnd: (event) => processDragEnd(event, context),
  });
};

export default useMobileDndReorder;
